import { Outlet } from 'react-router-dom';
import { Container, Stack } from '@mui/material';

import Header from 'layout/material/Header';
import Footer from 'layout/material/Footer';

const MaterialLayout = () => {
  return (
    <Stack className="flex-auto items-center w-full min-w-0 bg-default">
      <Header />
      <Container disableGutters maxWidth="lg" className="flex flex-auto">
        <Stack className="flex-auto w-full sm:mx-8 sm:shadow-xl bg-paper">
          <Outlet />
        </Stack>
      </Container>
      <Footer />
    </Stack>
  );
};

export default MaterialLayout;
